// Importaciones de librerías externas
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

// Importaciones de entidades del proyecto
import { Rol } from "@shared/Entities/Rol/rol.entity";
import { RolesRepository } from "@shared/Repositories/roles.repository";
import { UsuarioCorporativoFiduciaria } from "@shared/Entities/Fiduciaria/usuarioCorporativoFiduciaria";

// Importaciones de entidades Fiduciarias
import { Escrow } from "@fiduciaria/Shared/Types/escrow.interface";
import { Dependency } from "@fiduciaria/Shared/Types/dependency.interface";
import { FiduciariaPermisosRole } from "@shared/Entities/Fiduciaria/FiduciariaPermisosRole.entity";

// Importaciones de repositorios
import { CanalesUserFiduciaryRepository } from "../Repository/canales-user-fiduciary.repository";

@Injectable()
export class NuevoFiduciariaService {

  public roles: Rol[];
  constructor(
    private readonly fiduciaryAdministracionRepository: CanalesUserFiduciaryRepository, 
    private readonly rolesRepositorio: RolesRepository
  ) {}

  public getUserFideicomisos(): Observable<Escrow[]> {
    return this.fiduciaryAdministracionRepository.getUserFideicomisos();
  }

  public getUserFideicomisosByUserId(userId: number): Observable<Escrow[]> {
    return this.fiduciaryAdministracionRepository.getUserFideicomisosByUserId(userId);
  }
  
  public getAreasByIdFideicomiso(idFideicomiso: number): Observable<Dependency[]> {
    return this.fiduciaryAdministracionRepository.getAreasByIdFideicomiso(idFideicomiso);
  }

  public getEscrows(): Observable<Escrow[]> {
    return this.fiduciaryAdministracionRepository.getEscrows();
  }

  public getDependencies(): Observable<Dependency[]> {
    return this.fiduciaryAdministracionRepository.getDependencies();
  }

  public getFiduciariaPermisosRole(): Observable<FiduciariaPermisosRole[]> {
    return this.fiduciaryAdministracionRepository.getFiduciariaPermisosRole();
  }

  public getPermisosByUserId(guiId: string): Observable<FiduciariaPermisosRole[]> {
    return this.fiduciaryAdministracionRepository.getPermisosByUserId(guiId);
  }

  public getUsuariosAdminFiduciaria(): Observable<UsuarioCorporativoFiduciaria[]> {
    return this.fiduciaryAdministracionRepository.getUsuariosAdminFiduciaria();
  }
}
